<div
  *ngIf="flash() && !isSearch"
  [ngClass]="flash().class"
  [innerHTML]="flash().msg"
></div>

<empty-customer-pending 
  *ngIf="showEmptyStateCustomerPending"
  [customer]="customer"
></empty-customer-pending>
<empty-customer-expired
  *ngIf="showEmptyStateCustomerExpired"
  [customer]="customer"
></empty-customer-expired>
<empty-white-label-no-subscriptions
  *ngIf="showEmptyWhiteLabelNoSubscriptions"
  [agencyName]="agencyName"
></empty-white-label-no-subscriptions>

<div *ngIf="submissionsLoading" class="loader">Loading...</div>
<queued-submissions-list
  *ngIf="showSubmissionList"
  [customer]="customer"
  [currentUser]="currentUser"
  [posts]="posts"
  [submissions]="submissions"
  [isSearch]="isSearch"
  (deprecatedStoreChange)="onDeprecatedStoreChange($event)"
  (action)="onAction($event)"
  (accept)="onAccept($event)"
  (requestEdits)="onRequestEdits($event)"
  (pendingRequests)="showPendingRequestsWarning= $event"
>
  <ng-container list-top-controls>
    <ng-content select="[list-top-controls]"></ng-content>
  </ng-container>
</queued-submissions-list>
